import { HomeQuery } from '@layouts/home'

const Home = (props) => {
  return <HomeQuery {...props} />
}

Home.getInitialProps = async ({ query, req }) => {
  const reqHeaders = req ? req.headers : {}
  return { query, reqHeaders }
}

export default Home
